<h2>PRÉAMBULE</h2>
<p>
  La connexion et l’accès au site/application TIMECHEF (ci-après le « Site Timechef » ou le « Site ») impliquent l’acception intégrale et sans réserve par
  l’Utilisateur des présentes Conditions Générales d’Utilisation.
</p>
<p>L’ensemble de ces dispositions s’impose aux Utilisateurs qui doivent consulter les présentes Conditions Générales d’Utilisation lors de chaque connexion.</p>
<p>
  La société éditrice a mise en ligne ce Site afin de Vous permettre de créer et de gérer un compte « TIMECHEF » qui vous permet d’approvisionner votre carte de
  cantine, d’avoir accès à l’historique de vos opérations en ligne et d’avoir accès à des services et offres sur internet.
</p>
<p>
  Il est précisé que la société éditrice du Site peut proposer d’autres services via ce Site pour lesquels des conditions d’utilisation spécifiques devront être
  acceptées avant toute utilisation. Dans cette hypothèse les nouvelles Conditions d’Utilisation viendront compléter les présentes.
</p>

<h2>EDITEUR / DIRECTEUR DE LA PUBLICATION</h2>
<h2>Editeur :</h2>
<p>
  ELIOR RC FRANCE, Société par actions simplifiées au capital de 10.000 Euros, ayant son siège social sis 9-11 Allée DE L’ARCHE 92032 Paris La Défense Cedex, et
  inscrite au RCS Nanterre n° 750 433 930.
  <br />
  Téléphone : 01.71.06.70.00
</p>

<h2>Directeur de la rédaction</h2>
<p>Philippe CHRISTON</p>

<h2>HÉBERGEUR</h2>
<p>
  ELIOR DATA, Service PORTAILS, 9-11 Allée DE L’ARCHE 92032 Paris La Défense Cedex
  <br />
  Téléphone : 01.71.06.70.00
</p>

<h2>DEFINITIONS</h2>
<p>
  « Données personnelles » désigne les données concernant les personnes physiques et permettant de les identifier directement ou indirectement. Il est précisé
  qu’aucune donnée personnelle dite « sensible » (à savoir notamment d’origine raciale, opinion politique, philosophique ou religieuse, appartenance syndicale,
  mœurs des personnes) n’est collectée.
</p>
<p>« Informations » désigne l’ensemble du contenu à caractère informationnel ou non disponible sur le Site.</p>
<p>
  « Sociétés du Groupe » désigne soit l’ensemble des sociétés du Groupe ELIOR, soit une société du groupe lorsqu’il est inutile de l’identifier en particulier.
  Il est rappelé que les Sociétés du Groupe ont leur propre existence légale et disposent d’une personnalité juridique autonome. L’utilisation du terme «
  Sociétés du Groupe » ne saurait donc constituer la preuve d’un groupement solidaire tant entre lesdites sociétés du Groupe ELIOR que vis-à-vis des
  Utilisateurs du Site ou plus largement des tiers.
</p>
<p>« Vous » ou « L’Utilisateur » désigne tout visiteur du Site, client de la société éditrice ou non.</p>

<h2>DROITS DE PROPRIÉTÉ INTELLECTUELLE</h2>
<h2>Droits d'auteur :</h2>
<p>
  Le Site Timechef constitue une création intellectuelle dont ELIOR RC FRANCE, Société du groupe ELIOR est l'auteur au sens des articles L. 111.1 et suivants du
  Code de la propriété intellectuelle.
</p>
<p>
  L’ensemble des éléments disponibles sur le site dont notamment les photographies, textes, slogans, dessins, images, icônes, sons, séquences animées sonores ou
  non ainsi que toutes créations intellectuelles intégrées dans le Site dont notamment les bases de données et logiciels sont la propriété de ELIOR RC FRANCE
  et/ou des Sociétés du Groupe ELIOR ou de tiers ayant autorisé ELIOR RC FRANCE et/ou les Sociétés du Groupe ELIOR à les utiliser. Par conséquent, les droits de
  reproduction et de représentation de l’ensemble des éléments présentés sur le site sont strictement réservés et soumis à l’autorisation préalable et expresse
  de ELIOR RC FRANCE.
</p>
<p>
  L’accès au Site ne Vous confère aucun droit sur les droits de propriété intellectuelle relatifs au Site qui restent la propriété exclusive de la Société
  éditrice du Site et/ou des Sociétés du Groupe ou leurs partenaires.
</p>
<p>
  Toute reproduction, représentation, utilisation, adaptation ou modification, par quelque procédé que ce soit et sur quelque support que ce soit, de tout ou
  partie du Site Timechef, sans avoir obtenu l'autorisation expresse de ELIOR RC FRANCE est strictement interdite et constitue un délit de contrefaçon.
</p>
<h2>Droits des marques :</h2>
<p>Les dénominations sociales, marques et signes distinctifs reproduits sur le Site Timechef sont protégés au titre du droit des marques.</p>
<p>A ce titre, l'appellation Elior, le logo Elior, sont des marques déposées par les Sociétés du groupe ELIOR.</p>
<p>
  D'autres marques sont citées et identifiées par une majuscule. Ces marques appartiennent généralement à ELIOR RC FRANCE et/ou à des sociétés du Groupe Elior
  ou l’une de ces sociétés en détient les droits d’utilisation afférents, et sont également protégées au titre du droit des marques.
</p>
<p>
  D’autres marques sont également présentées sur ce site, bien que ELIOR RC FRANCE et/ou les Sociétés du Groupe ELIOR n’en détienne pas la propriété, elle
  bénéficie des droits d’utilisation.
</p>
<p>
  La reproduction, la représentation, l’utilisation, l’adaptation ou la modification de ces marques sans avoir obtenu l'autorisation préalable de ELIOR RC
  FRANCE est strictement interdite et constitue un délit de contrefaçon.
</p>

<h2>CRÉATION DE LIEN</h2>
<p>Le site Timechef autorise la mise en place d’un lien hypertexte pointant vers son contenu, sous réserve de respecter les points suivants :</p>
<p>
  - interdiction de toute utilisation du lien profond (« framing ») en conséquence, aucun élément figurant sur une page du Site Timechef ne peut être
  partiellement ou totalement diffusé, transféré ou inséré sur un autre site internet, ni servir à créer des produits dérivés.
  <br />
  - mentionner la source du contenu visé.
</p>

<h2>PROTECTION DES DONNÉES PERSONNELLES</h2>
<p>
  Les données personnelles recueillies sur le site TIMECHEF dans le cadre des formulaires d’inscription et de contact, services personnalisés ou tout autre
  questionnaire font l’objet d’un traitement automatisé par la société ELIOR ENTREPRISES, ARPEGE, ELRES, ANSAMBLE, L’ALSACIENNE DE RESTAURATION ou tout autre
  Société du groupe ELIOR qui est le responsable du traitement.
</p>
<p>
  Les données personnelles sont collectées en vue de Vous permettre de créer et de gérer un compte TIMECHEF (notamment : Vous permettre d’alimenter votre carte
  de cantine par paiement en ligne, de passer en caisse avec accès ticket dématérialisé), Vous faire bénéficier de services en ligne (notamment : consultation
  de l’affluence d’un restaurant et du menu) , Vous faire bénéficier de service de commande en ligne, répondre à vos demandes, Vous contacter et/ou Vous
  informer sur l’exécution d’un service, sur votre suivi de consommation, sur le solde de votre compte convive, sur les services que nous proposons, sur du
  contenu personnalisé et sur toutes informations utiles.
</p>
<p>
  Vous pouvez décider de ne pas nous communiquer vos données personnelles, cependant, certaines informations demandées dans les formulaires en ligne sont
  obligatoires. En cas d’absence de saisie ou de saisie erronée, les informations ne sont pas envoyées au responsable du traitement et Vous ne pourrez pas
  bénéficier des services du site TIMECHEF.
</p>
<p>
  Les données de votre suivi de consommation sont obtenues par interrogation des données collectées par les systèmes de caisse de Votre cantine lors de votre
  passage en caisse.
</p>
<p>
  Les données personnelles collectées via le Site TIMECHEF sont utilisées exclusivement pour la réalisation des services du Site TIMECHEF. A ce titre, les
  destinataires de ces données sont les services du responsable du traitement et ses sous- traitants ainsi que tout autre service d’une société membre du Groupe
  ELIOR intervenant dans la réalisation du traitement.
</p>
<p>
  La base légale des traitements de données personnelles Vous permettant d’accéder à votre compte TIMECHEF et de le gérer est Votre consentement. Vous pouvez
  gérer et modifier vos préférences à tout moment en Vous rendant dans l’onglet « Mon Compte ».
</p>
<p>
  La base légale des traitements de données personnelles pour communiquer avec Vous en général est l’intérêt légitime du responsable de traitement (tenir les
  dossiers à jour et étudier comment Vous utilisez les services de votre compte TIMECHEF, gérer efficacement vos demandes et notre activité, maintenir le site
  TIMECHEF à jour et pertinent).
</p>
<p>L'application et ses données sont hébergées sur des centres de données localisés en France.</p>
<p>
  Les données personnelles sont stockées par le responsable du traitement et/ou ses sous-traitants et sont conservées de manière sécurisée pour la durée
  nécessaire à la réalisation des finalités énoncées ci-dessus pour lesquelles elles sont collectées, en conformité avec la réglementation en vigueur et jusqu’à
  la fermeture de votre compte TIMECHEF.
</p>
<p>
  Conformément à la réglementation en vigueur et notamment le Règlement (UE) 2016/679 du 27 avril 2016, Vous bénéficiez d’un droit d’accès à vos données
  personnelles, d'un droit de rectification et d'effacement de ces données, d'un droit de limitation du traitement de ces données, d'un droit à la portabilité
  de ces données et d'un droit d'opposition à leur traitement. Vous pouvez exercer à tout moment ces droits auprès de notre Délégué à la protection des données
  en adressant un courrier à « ELIOR Entreprises - Service Monétique – Tour Egée 9-11 Allée DE L’ARCHE 92032 Paris La Défense Cedex » ou par email à
  gdpr-contact&#64;eliorgroup.com
</p>
<p>Vous avez la possibilité de vérifier, compléter et supprimer les informations que Vous avez fournies en accédant à la section « Mon Compte ».</p>
<p>
  Pour toute information sur la protection des données personnelles, Vous pouvez consulter le site de la Commission Nationale de l’Informatique et des Libertés
  : http://www.cnil.fr. Si vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne sont pas respectées, vous pouvez adresser
  une réclamation à la CNIL.
</p>
<h2>Données de géolocalisation :</h2>
<p>
  Lorsque Vous utilisez le site/application Timechef, et si Vous avez consenti à des services de localisation, le responsable du traitement peut recevoir des
  informations concernant votre localisation.
</p>
<p>
  Le responsable du traitement peut utiliser ces informations pour Vous fournir des services liés à la localisation, tels que Vous proposer des sites Elior
  géolocalisés à proximité de l’endroit où Vous vous trouvez.
</p>
<p>Ces données de localisation ne sont pas conservées par le responsable du traitement au-delà du temps de connexion de l’Utilisateur.</p>
<p>
  La plupart des appareils portables Vous permettent de désactiver les services de localisation ; Vous pouvez donc à tout moment désactiver les notifications
  dans les paramétrages de votre appareil en Vous rapportant à sa documentation technique.
</p>
<h2>Notification par SMS/Email/Push :</h2>
<p>
  Lorsque Vous utilisez le site/application Timechef, et si Vous avez consenti à des notifications SMS et/ou Email et/ou Push, le responsable du traitement peut
  Vous envoyer des informations concernant le solde de votre compte, la confirmation de votre paiement en ligne, du contenu personnalisé et toutes informations
  utiles concernant votre compte restauration et sur les services et offres en cours.
</p>
<p>Vos données personnelles seront utilisées pour l’envoi d’éventuels messages de partenaires commerciaux qu’avec votre consentement préalable.</p>
<p>L’envoi de notification par SMS ou par Email ou Push peut être activé ou désactivé à tout moment en se rendant dans l’onglet « Mon Compte ».</p>

<h2>"COOKIES"</h2>
<p>
  Le cookie est un petit bloc de données envoyé à votre ordinateur par un serveur web et stocké sur le disque dur de votre ordinateur. De manière générale, il
  nous permet d’enregistrer des informations relatives à la navigation de votre ordinateur sur notre site (exemple : pages consultées, date et heure de
  consultation,…).
</p>
<p>
  Tout internaute peut s’opposer à l’enregistrement de cookies en se rapportant au manuel d’utilisation de son navigateur. Tout internaute peut également
  supprimer les cookies à tout moment et individuellement en se rapportant au manuel d’utilisation de son ordinateur.
</p>

<h2>ALLERGÈNES</h2>
<p>
  Nos informations sur les allergènes concernent exclusivement les 14 allergènes majeurs que nous avons introduits volontairement dans nos préparations. Dans
  notre cuisine, toutes ou partie de ces substances allergènes sont présentes. Aussi, malgré toutes nos précautions, nous ne pouvons pas exclure la
  contamination croisée accidentelle entre préparations.
</p>
<p>L’affichage des substances allergènes est effectué, à date, sur la base des informations communiquées par nos fournisseurs sur leurs propres produits.</p>
<p>
  Les informations sur les substances allergènes sont données à titre indicatif. Les informations d’étiquetage qui font foi sont celles affichées dans votre
  restaurant.
</p>

<h2>RESPONSABILITÉ</h2>
<p>Les éléments indiqués sur le Site Timechef sont donnés à titre indicatif et ne revêtent aucun caractère contractuel.</p>
<p>
  Vous reconnaissez utiliser les informations contenues dans le Site sous votre propre responsabilité et assumez pleinement les risques liés au crédit que vous
  pourriez leur accorder.
</p>
<p>
  Ni ELIOR RC FRANCE, ni aucune autre Société du Groupe ne saurait être tenu responsable :
  <br />
  - pour toute imprécision, inexactitude ou omission portant sur des informations indiquées sur le Site Timechef,
  <br />
  - pour tous éventuels dommages, directs et/ou indirects, quelles qu’en soient les causes, origines, natures ou conséquences, provoqués en raison de l’accès au
  Site Timechef ou de l’impossibilité d’y accéder,
  <br />
  - pour tous éventuels dommages, directs et/ou indirects, subis sur le matériel, la perte de données, et/ou le préjudice financier qui pourrait résulter de la
  connexion ou de l’utilisation des informations recueillies sur le Site Timechef.
</p>
<p>
  La Société éditrice du Site décline formellement toute responsabilité quant aux contenus des sites vers lesquels elle offre des liens. Ces liens Vous sont
  proposés en tant que service. La décision d’activer les liens Vous appartient exclusivement.
</p>
<p>
  ELIOR RC FRANCE se réserve le droit de modifier, de corriger ou de supprimer le contenu du Site Timechef et/ou les présentes Conditions Générales
  d’Utilisation à tout moment, sans préavis, étant précisé que la modification et l’actualisation des Conditions Générales d’Utilisation s’imposent dès leur
  mise en ligne.
</p>
<p>Il appartient à l’Utilisateur de prendre toutes les mesures nécessaires pour protéger son matériel, ses données et logiciels informatiques.</p>

<h2>RESPECT DES RÉGLEMENTATIONS ET DE LA DÉONTOLOGIE</h2>
<p>Les présentes Conditions Générales d’Utilisation sont soumises au droit français.</p>
<p>Les internautes se connectant au Site Timechef à partir d’autres pays que la FRANCE, doivent s’assurer du respect des lois applicable à ces pays.</p>
<p>
  Tout litige relatif à l’interprétation, l’application et/ou à l’exécution des présentes sera soumis à la juridiction compétente des Tribunaux du ressort de la
  Cour d’Appel de Versailles.
</p>
